<div class="topDiv" [style.background-color]="backgroundColorScreen">

    <div class="agGridOuterDiv">
        <div style="display: flex;">
        <div style="margin-top:3%;margin-right: 20px;">
             <div style="border-bottom: 1px solid #ddd; padding: 8px 8px 0px; font-size: 0.9rem;    width: 125px;">
                <div style="display: flex;">
                    <div style="width: 100%;">
                        <h4 style="font-size: 16px; font-weight: 500; cursor: pointer;" (click)="study()">Study</h4>
                    </div>
                </div>
                <div *ngIf="studyCondition">

                <div style="height: 150px;
                overflow: auto;">
                    <div *ngFor='let study of studyFilter; let i = index;'>
                        <mat-checkbox [(ngModel)]="study.checkedorunchecked" (change) = "checked($event,study)">{{study.object}}</mat-checkbox>
                    </div>
                </div>
            </div>
            </div>
            
            <div style="border-bottom: 1px solid #ddd; padding: 8px 8px 0px; font-size: 0.9rem;    width: 125px;">
                <div style="display: flex;">
                    <div style="width: 100%;">
                        <h4 style="font-size: 16px; font-weight: 500;cursor: pointer;" (click)="product()">Product</h4>
                    </div>
                </div>
                <div *ngIf="productCondition">

                    <div style="height: 150px;
                    overflow: auto;">
                        <div *ngFor='let product of productFilter; let i = index;'>
                            <mat-checkbox [(ngModel)]="product.checkedorunchecked" (change) = "checked($event,product)">{{product.object}}</mat-checkbox>
                        </div>
                    </div>
                </div>
            </div>
            <div style="border-bottom: 1px solid #ddd; padding: 8px 8px 0px; font-size: 0.9rem;    width: 125px;">
                <div style="display: flex;">
                    <div style="width: 100%;">
                        <h4 style="font-size: 16px; font-weight: 500;cursor: pointer;" (click)="Seriousness()">Seriousness</h4>
                    </div>
                </div>
                <div *ngIf="seriousnessCondition">

                    <div style="height: 150px;
                    overflow: auto;">
                        <div *ngFor='let seriousness of seriousnessFilter; let i = index;'>
                            <mat-checkbox [(ngModel)]="seriousness.checkedorunchecked" (change) = "checked($event,seriousness)">{{seriousness.object}}</mat-checkbox>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" (click)="clearSelected()" [style.background-color]="buttonColor" title="clear" >Clear Filters
                </button>
            </div>
            <div>
                <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="buttonColor" title="clear" >Add Filters
                </button>
            </div>
        </div>
        <div style="margin-top: 4px;
        width: 1196px;">
            <div>
                <mat-toolbar class="agGridtoperDiv card" style="
                        background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8;
                border-right: 1px solid #a9a9a9a8;
                border-left: 1px solid #a9a9a9a8;">
                            <label i18n="@@spmsUserReg" class="textColour">Cases</label>
                            <span class="example-spacer"></span>
                            <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="buttonColor" title="Download" (click) = "onBtExport()">Download
                                <em style="padding: 0px 0px 0px 10px;" class="fas fa-download example-icon" title="Download"></em>
                        </button>
                            <div class="insertPageNoDiv">
                                <mat-form-field appearance="outline">
                                    <mat-label i18n="@@Targetpageno">From</mat-label>
                                    <input matInput type="text" (input)="onSearchChange($event)">
                                </mat-form-field>
                            </div>
                         
                            <div class="card pagination paginationFirstButton paginationFirstlastButton">
                                <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirst()"></em>
                            </div>
                            <div class="card pagination paginationButtons btn-rounded">
                                <ul>
                                    <li class="paginationliicon"><em class="fas fa-angle-left waves-effect waves-light"
                                            (click)="pre()"></em></li>
                                    <li>{{from}} of {{totalCount}}</li>
                                    <li class="paginationliicon" style="padding:0;"><em
                                            class="fas fa-angle-right waves-effect waves-light" (click)="next()"></em></li>
                                </ul>
                            </div>
             
                <div class="card pagination paginationLastButton paginationFirstlastButton">
                    <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLast()"></em>
                </div>
                        </mat-toolbar>
                    </div>
            <ag-grid-angular class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
            [columnDefs]="columnDefs" [animateRows]="true"  [pagination]="true"
            [rowSelection]="rowSelection" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35"
            [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"
             [paginationNumberFormatter]="paginationNumberFormatter"
            [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules"
            [components]="components"
            (gridReady)="onGridReady($event,add,minus,filters)" [hidden]="!true"></ag-grid-angular>
        </div>
    </div>
    </div>
</div>
